"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var initialParams = {};
var List = function () {
    var _a = ra_fetch_1.useApi('auth').index('roles', initialParams), roles = _a[0], setRoles = _a[1], params = _a[2], setParams = _a[3];
    return (react_1.default.createElement(storybook_1.Layouts.Container, null, Boolean(roles.data.length) && react_1.default.createElement(storybook_1.Roles.List, { roles: roles })));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * The Params for the request
     */
    params: prop_types_1.default.object,
};
exports.List.defaultProps = {};
